module.exports = __webpack_public_path__ + "img/team-5.66b80bb3.jpg";